const KPP_TYPES = {
  registration: '01',
  bigTaxPayer: '50',
  envd: '35/77',
  branch: 'branch'
}

export {
  KPP_TYPES
}
